import { Routes, Route, Navigate } from 'react-router-dom'
import LoginPage from './components/auth/LoginPage'
import ProtectedRoute from './components/auth/ProtectedRoute'
import Layout from './components/common/Layout'
import AdminLayout from './components/admin/AdminLayout'
import LorePage from './pages/LorePage'
import LoreArticlePage from './pages/LoreArticlePage'
import TimelinePage from './pages/TimelinePage'
import AlbumsPage from './pages/AlbumsPage'
import CharactersPage from './pages/CharactersPage'
import ToolsPage from './pages/ToolsPage'
import CharacterDetailPage from './pages/CharacterDetailPage'
import ShipsPage from './pages/ShipsPage'
import ShipDetailPage from './pages/ShipDetailPage'
import AdminDashboard from './pages/AdminDashboard'
import CharacterList from './components/admin/CharacterList'
import CharacterEditor from './components/admin/CharacterEditor'
import AlbumList from './components/admin/AlbumList'
import AlbumEditor from './components/admin/AlbumEditor'
import EventList from './components/admin/EventList'
import EventEditor from './components/admin/EventEditor'
import LoreList from './components/admin/LoreList'
import LoreEditor from './components/admin/LoreEditor'
import HandoutList from './components/admin/HandoutList'
import HandoutEditor from './components/admin/HandoutEditor'
import ShipList from './components/admin/ShipList'
import ShipEditor from './components/admin/ShipEditor'
import CipherList from './components/admin/CipherList'
import CipherEditor from './components/admin/CipherEditor'
import SpellList from './components/admin/SpellList'
import SpellEditor from './components/admin/SpellEditor'
import SpellSchoolList from './components/admin/SpellSchoolList'
import SpellSchoolEditor from './components/admin/SpellSchoolEditor'
import UserWhitelist from './components/admin/UserWhitelist'
import LoginAttempts from './components/admin/LoginAttempts'
import SiteSettingsEditor from './components/admin/SiteSettingsEditor'
import MigrateEvents from './components/admin/MigrateEvents'
import CipherToolPage from './pages/CipherToolPage'
import SpellbookPage from './pages/SpellbookPage'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/lore" replace />} />
        <Route path="lore" element={<LorePage />} />
        <Route path="lore/:slug" element={<LoreArticlePage />} />
        <Route path="timeline" element={<TimelinePage />} />
        <Route path="albums" element={<AlbumsPage />} />
        <Route path="characters" element={<CharactersPage />} />
        <Route path="characters/:id" element={<CharacterDetailPage />} />
        <Route path="ships" element={<ShipsPage />} />
        <Route path="ships/:id" element={<ShipDetailPage />} />
        <Route path="tools" element={<ToolsPage />} />
        <Route path="tools/cipher" element={<CipherToolPage />} />
        <Route path="spellbook" element={<SpellbookPage />} />

        <Route path="admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="events" element={<EventList />} />
          <Route path="events/:id" element={<EventEditor />} />
          <Route path="characters" element={<CharacterList />} />
          <Route path="characters/:id" element={<CharacterEditor />} />
          <Route path="albums" element={<AlbumList />} />
          <Route path="albums/:id" element={<AlbumEditor />} />
          <Route path="lore" element={<LoreList />} />
          <Route path="lore/:id" element={<LoreEditor />} />
          <Route path="handouts" element={<HandoutList />} />
          <Route path="handouts/:id" element={<HandoutEditor />} />
          <Route path="ships" element={<ShipList />} />
          <Route path="ships/:id" element={<ShipEditor />} />
          <Route path="ciphers" element={<CipherList />} />
          <Route path="ciphers/:id" element={<CipherEditor />} />
          <Route path="spells" element={<SpellList />} />
          <Route path="spells/:id" element={<SpellEditor />} />
          <Route path="spell-schools" element={<SpellSchoolList />} />
          <Route path="spell-schools/:id" element={<SpellSchoolEditor />} />
          <Route path="users" element={<UserWhitelist />} />
          <Route path="login-attempts" element={<LoginAttempts />} />
          <Route path="settings" element={<SiteSettingsEditor />} />
          <Route path="migrate" element={<MigrateEvents />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/lore" replace />} />
    </Routes>
  )
}
